export function VideoPlayer({ playbackId, title }) {
  if (!playbackId) return null;

  return (
    <div style={{ position: "relative", paddingBottom: "56.25%", height: 0, borderRadius: 12, overflow: "hidden", background: "#000" }}>
      <iframe
        src={`https://stream.mux.com/${playbackId}`}
        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: "none" }}
        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
        allowFullScreen
        title={title || "Course video"}
      />
    </div>
  );
}